import { Box } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import type { LinkExternalDto } from '@hcr/api/optimizely'
import { DividerWithLabel, ICONS } from '@hcr/ui'

import { Path } from '../../../../../models'
import { createLinkExternal, to } from '../../../../../utils'
import { Link } from '../link'

interface UsefulLinksProps {
  links: LinkExternalDto[]
}

export const UsefulLinks: FC<UsefulLinksProps> = ({ links }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <DividerWithLabel>{t('account.useful-links')}</DividerWithLabel>
      {links.map(createLinkExternal).map(link => (
        <Link
          to={link.to}
          key={link.label}
          target='_blank'
          rel='external'
          title={link.label}
          icon={ICONS.farArrowUpRightFromSquare}
        />
      ))}
      <Link to={to(Path.About)} title={t('account.about-the-app')} />
    </Box>
  )
}
